import React, { useEffect, useState } from 'react';
import { API_URL } from '../../config';
import { authFetch } from '../../utils';
import UserForm from './UserForm';

export default function UserList() {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingUsername, setEditingUsername] = useState(null);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);

  useEffect(() => {
    authFetch(`${API_URL}auth/`)
      .then(res => res.json())
      .then(setUsers)
      .catch(console.error);
  }, []);

  const handleDelete = async (username) => {
    const confirmDelete = window.confirm(`¿Eliminar al usuario "${username}"?`);
    if (!confirmDelete) return;

    const res = await authFetch(`${API_URL}auth/${username}`, { method: 'DELETE' });
    if (res.ok) {
      setUsers(prev => prev.filter(u => u.username !== username));
      setDeleteSuccess(true);
      setTimeout(() => setDeleteSuccess(false), 3000);
    } else {
      alert('Error al eliminar el usuario');
    }
  };

  const filteredUsers = users.filter(u =>
    u.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    u.fullname?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '1rem' }}>
      <h2 style={{ fontSize: '1.8rem', marginBottom: '1rem', textAlign: 'center' }}>
        👥 Usuarios
      </h2>

      <button
        onClick={() => setShowCreateForm(true)}
        style={{ backgroundColor: '#28a745', color: '#fff', border: 'none', padding: '0.5rem 1rem', borderRadius: '4px', cursor: 'pointer', marginBottom: '1rem' }}
      >
        ➕ Nuevo usuario
      </button>

      {showCreateForm && (
        <UserForm
          user={null}
          onSave={(newUser) => {
            setUsers(prev => [...prev, newUser]);
            setShowCreateForm(false);
          }}
          onCancel={() => setShowCreateForm(false)}
        />
      )}

      <input
        type="text"
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        placeholder="Buscar por usuario o nombre..."
        style={{
          width: '100%',
          padding: '0.75rem',
          fontSize: '1rem',
          marginBottom: '1.5rem',
          borderRadius: '6px',
          border: '1px solid #ccc'
        }}
      />

      {deleteSuccess && (
        <div style={{
          backgroundColor: '#d4edda',
          color: '#155724',
          padding: '0.75rem',
          borderRadius: '6px',
          border: '1px solid #c3e6cb',
          marginBottom: '1rem',
          textAlign: 'center'
        }}>
          ✅ Usuario eliminado correctamente
        </div>
      )}

      <ul style={{ listStyle: 'none', padding: 0 }}>
        {filteredUsers.map(user => (
          <li
            key={user.username}
            style={{
              backgroundColor: '#f9f9f9',
              border: '1px solid #ddd',
              borderRadius: '8px',
              padding: '1rem',
              marginBottom: '1rem',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}
          >
            {editingUsername === user.username ? (
              <UserForm
                user={user}
                onSave={(updatedUser) => {
                  setUsers(prev =>
                    prev.map(u => u.username === updatedUser.username ? updatedUser : u)
                  );
                  setEditingUsername(null);
                }}
                onCancel={() => setEditingUsername(null)}
              />
            ) : (
              <>
                <div style={{ marginBottom: '0.5rem' }}>
                  <strong>Usuario:</strong> {user.username}
                </div>
                <div><strong>Nombre:</strong> {user.fullname || '—'}</div>
                <div style={{ marginTop: '0.5rem' }}>
                  <strong>Roles:</strong>{' '}
                  {user.roles?.length
                    ? user.roles.map(role => (
                      <span
                        key={role}
                        style={{
                          display: 'inline-block',
                          backgroundColor: '#e2e6ea',
                          color: '#333',
                          borderRadius: '12px',
                          padding: '0.15rem 0.6rem',
                          fontSize: '0.8rem',
                          marginRight: '0.35rem',
                          marginTop: '0.25rem'
                        }}
                      >
                        {role}
                      </span>
                    ))
                    : <span style={{ color: '#888' }}>Sin roles</span>}
                </div>

                <div style={{ marginTop: '1rem' }}>
                  <button
                    onClick={() => setEditingUsername(user.username)}
                    style={{
                      marginRight: '0.5rem',
                      padding: '0.5rem 1rem',
                      backgroundColor: '#007bff',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    Editar
                  </button>
                  <button
                    onClick={() => handleDelete(user.username)}
                    style={{
                      padding: '0.5rem 1rem',
                      backgroundColor: '#dc3545',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    Eliminar
                  </button>
                </div>
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
